import { render } from "./OcrReportTablesPanel.vue?vue&type=template&id=7b27169f"
import script from "./OcrReportTablesPanel.vue?vue&type=script&lang=js"
export * from "./OcrReportTablesPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__